var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectResident = function SvgSelectResident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1357 19.7371C21.1357 12.7027 26.8384 7.00008 33.8728 7.00008C40.9071 7.00008 46.6098 12.7027 46.6098 19.7371C46.6098 26.7715 40.9071 32.4741 33.8728 32.4741C26.8384 32.4741 21.1357 26.7715 21.1357 19.7371Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5981 50.8457C54.4189 40.3554 45.1425 32.4745 34.0293 32.4745H33.7191C22.6059 32.4745 13.3295 40.3554 11.1503 50.8457C9.57458 58.4297 20.632 60.8485 32.8365 60.9932",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2524_7959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.204 50.6486L41.7422 54.8652",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5523 48.4593L47.1323 50.3423",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2921 50.0473L44.437 52.6035",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1043 54.8105L31.9849 48.7094C31.366 47.9719 31.4239 46.8642 32.1452 46.2298C32.891 45.5737 34.0244 45.6672 34.6567 46.4207L38.4652 50.9595C37.8399 50.2143 37.9364 49.1042 38.6806 48.4797C39.0525 48.1677 39.5162 48.0362 39.965 48.0757C40.4137 48.1152 40.8477 48.3259 41.1601 48.6982L42.2922 50.0474C41.6669 49.3022 41.7633 48.1921 42.5075 47.5676C42.8794 47.2555 43.3431 47.124 43.7919 47.1635C44.2407 47.2031 44.6746 47.4137 44.9871 47.7861L45.552 48.4593L45.6184 48.5384C45.5961 48.5119 45.575 48.4851 45.5549 48.4583",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9614 54.6405L40.8887 59.3208",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8848 50.043L46.4765 49.5564",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7854 56.8144L38.7764 56.8228",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2222 59.2328C35.9099 58.8607 35.7779 58.397 35.8171 57.9488C35.8568 57.5002 36.0669 57.0669 36.439 56.7547C37.1302 56.1746 38.1363 56.2169 38.7762 56.8227C38.8254 56.8686 38.8726 56.9185 38.9171 56.9715L40.8888 59.3212",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4741 49.5581L46.4764 49.5562L46.4018 49.4673C45.7431 48.6823 45.8441 47.5129 46.6273 46.8557C47.0044 46.5393 47.4721 46.3985 47.9301 46.4265C48.3876 46.4549 48.8353 46.6521 49.1724 47.0118",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1725 47.0118L52.5707 51.0616C54.6983 53.5972 54.3676 57.3774 51.832 59.505L47.3972 63.2263C44.8616 65.3539 41.0814 65.0231 38.9538 62.4876L36.2226 59.2326",
    stroke: "#757575",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2524_7959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3502,
    height: 24.9459,
    fill: "white",
    transform: "translate(26.0024 49.7607) rotate(-40)"
  })))));
};
export default SvgSelectResident;